// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftHeader__container-ca7215 {
  height: 64px;
  padding: 0 22px 0 34px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--base-20);
}

.DraftHeader__right-block-c59227 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.DraftHeader__left-block-e07598 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.DraftHeader__icon-b03425 {
  fill: var(--base-120);
}

.DraftHeader__deleteIcon-d8a069 {
  margin-inline-end: 30px;
}

.DraftHeader__title-a61ff7 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
  margin-inline-start: 27px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/DraftHeader/styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  height: 64px;\n  padding: 0 22px 0 34px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.right-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.left-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  fill: var(--base-120);\n}\n\n.deleteIcon {\n  margin-inline-end: 30px;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n  margin-inline-start: 27px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DraftHeader__container-ca7215`,
	"right-block": `DraftHeader__right-block-c59227`,
	"rightBlock": `DraftHeader__right-block-c59227`,
	"left-block": `DraftHeader__left-block-e07598`,
	"leftBlock": `DraftHeader__left-block-e07598`,
	"icon": `DraftHeader__icon-b03425`,
	"deleteIcon": `DraftHeader__deleteIcon-d8a069`,
	"title": `DraftHeader__title-a61ff7`
};
module.exports = ___CSS_LOADER_EXPORT___;
